var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from 'react';
import { useSignOut } from 'react-auth-kit';
import FadeIn from '../../../components/Animation/FadeIn';
import Paragraph from '../../../components/Typography/Paragraph';
import FormRow from '../../../components/Form/Row';
import TextInput from '../../../components/Fields/TextInput';
import { Fields } from '../../../utils/Fields';
import { useValidation } from '../../../hooks/useValidation';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Button from '../../../components/Button';
import Heading from '../../../components/Typography/Heading';
import ModalBasic from '../../../components/Modal/Basic';
import axiosInstance from '../../../config/axios';
import { api } from '../../../config/api';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { RoutePaths } from '../../../config/routes';
import { toast } from 'react-toastify';
import { useUser } from '../../../hooks/useUser';
import DashboardLoginsPassword from './Password';
import { deepEqual, pick } from '../../../utils/Objects';
import { usePlaceholder } from '../../../hooks/usePlaceholder';
var DashboardLogins = function () {
    var navigate = useNavigate();
    var signOut = useSignOut();
    var _a = useOutletContext(), user = _a.user, handleUser = _a.handleUser, handleFormError = _a.handleFormError;
    var removeUserStorage = useUser().removeUserStorage;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(false), modal = _c[0], setModal = _c[1];
    var emailRequired = useValidation().emailRequired;
    var placeholders = usePlaceholder();
    var schema = yup.object().shape({
        email: emailRequired,
    });
    var _d = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            email: user.email,
        },
    }), handleSubmit = _d.handleSubmit, control = _d.control, setError = _d.setError, reset = _d.reset;
    var handleEmailUpdate = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (deepEqual(data, pick(user, ['email'])))
                        return [2 /*return*/];
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, axiosInstance.post(api.user.emailUpdate, data)];
                case 2:
                    response = _a.sent();
                    handleUser(response.data);
                    reset(pick(response.data, ['email']));
                    toast.success('Votre email de connexion a bien été mis à jour');
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    if (error_1.response.status === 422) {
                        error_1.response.data.errors.forEach(function (error) {
                            setError(Object.keys(error)[0], { message: Object.values(error)[0] });
                        });
                    }
                    else {
                        handleFormError(error_1);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleDelete = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axiosInstance.delete(api.user.delete)];
                case 1:
                    response = _a.sent();
                    setModal(false);
                    toast.success('Votre compte a bien été supprimé');
                    removeUserStorage();
                    signOut();
                    navigate(RoutePaths.SIGN_IN, { replace: true });
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    handleFormError(error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (<FadeIn>
      <div className="my-10 grid gap-6 lg:my-20 lg:grid-cols-12">
        <div className="lg:col-span-10 lg:col-start-2 xl:col-span-8 xl:col-start-3">
          <div className="flex flex-col gap-6">
            <form onSubmit={handleSubmit(handleEmailUpdate)}>
              <FormRow>
                <TextInput label="Email de connexion" type={Fields.EMAIL} name="email" placeholder={placeholders.email} control={control} required/>
              </FormRow>
              <FormRow>
                <Button submit loading={loading} className="mt-4">
                  Mettre à jour mon email
                </Button>
              </FormRow>
            </form>
            <DashboardLoginsPassword />
            <Button onClick={function () { return setModal(true); }} type="outlined" alert="danger" className="mt-6 sm:self-start">
              Supprimer mon compte
            </Button>

            <ModalBasic handleClose={function () { return setModal(false); }} open={modal}>
              <div className="flex flex-col items-center gap-10">
                <Heading level={2} type="h5" className="text-center">
                  Souhaitez-vous vraiment supprimer votre compte&nbsp;?
                </Heading>
                <Paragraph className="text-center">
                  Vous ne pourrez plus accéder à votre compte et vous ne pourrez plus vous
                  connecter.
                </Paragraph>
                <div className="flex gap-6">
                  <Button onClick={handleDelete} type="outlined" alert="danger">
                    Supprimer
                  </Button>
                  <Button onClick={function () { return setModal(false); }} type="outlined">
                    Annuler
                  </Button>
                </div>
              </div>
            </ModalBasic>
          </div>
        </div>
      </div>
    </FadeIn>);
};
export default DashboardLogins;
